<script setup lang="ts">
import TableAlert from '@/components/alerts/TableAlert.vue';
import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import SuburbsSearchSearchForm from '@/components/searchForms/SuburbsSearchSearchForm.vue';
import SuburbsSearchTable from '@/components/tables/SuburbsSearchTable.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useSuburbsSearchViewData from '@/composables/data/useSuburbsSearchViewData';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import useDownloadCsv from '@/composables/useDownloadCsv';
import useSuburbsSearchView from '@/composables/views/useSuburbsSearchView';

const { querySuburb, queryPostCode } = useCommonRouteQuery({});
const { isDownloadingCSV, downloadCsv } = useDownloadCsv();
const { isFetchingSuburbs, suburbs } = useSuburbsSearchViewData(
  querySuburb,
  queryPostCode,
);
const { search, initialData, total, resultsForCsv } = useSuburbsSearchView(
  querySuburb,
  queryPostCode,
  suburbs,
);
</script>

<template>
  <div :class="$style.suburbsSearchView" data-testid="suburbsSearchView">
    <PageContentWrapper class="mt-2">
      <FormWrapper :class="$style.formWrapper" class="mt-0">
        <h2 class="g-h2">Search by suburb name or postcode</h2>
        <SuburbsSearchSearchForm
          :initial-data="initialData"
          :loading="isFetchingSuburbs"
          :class="$style.form"
          @submit="search"
        />
      </FormWrapper>
      <TableAlert v-if="total === 200" :class="$style.tableAlert">
        Only 200 jobs are shown. Please, specify your searching request
      </TableAlert>
      <TablePageShadowWrapper :class="$style.tablePageShadowWrapper">
        <SuburbsSearchTable :loading="isFetchingSuburbs" :data="suburbs" />
        <TablePageFooter v-if="suburbs?.length" :total="total" no-pages>
          <ExportAsCsvIconBtn
            :disabled="isFetchingSuburbs || !suburbs?.length"
            :loading="isDownloadingCSV"
            @click="downloadCsv(resultsForCsv, 'suburbsSearch')"
          />
        </TablePageFooter>
      </TablePageShadowWrapper>
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.suburbsSearchView {
}
  .formWrapper {
    padding: 0.5rem 1.5rem 0.5rem 1.5rem;
    max-width: variables.$tableWrapperWidth;
    margin: 2rem 0;
  }
  .tablePageShadowWrapper {
    max-width: variables.$tableWrapperWidth;
  }
  .tableAlert {
    margin-bottom: 14px;
  }
</style>
